import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import type { CategoryData } from '@occ/api-client';

const useCategoryMetadata = (categoryInfo: CategoryData | undefined) => {
  const t = useTranslations('categoryPage');

  useEffect(() => {
    const { name, parentCategoryName } = categoryInfo ?? {};
    if (!name) return;

    const title = parentCategoryName
      ? t('meta.titleWithParent', { name, parent: parentCategoryName })
      : t('meta.title', { name });

    const description = parentCategoryName
      ? t('meta.descriptionWithParent', { parentCategory: parentCategoryName, assortment: name })
      : t('meta.description', { assortment: name });

    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
  }, [categoryInfo, t]);
};

export default useCategoryMetadata;
